module.exports = __webpack_public_path__ + "img/background_startscreen.91580578.webp";